module.exports = __webpack_public_path__ + "img/pergola-over-door.956cd25f.jpg";